import { formatEnum } from "../utils/enumIslemTurFormat";
import { formatNumberTR } from "../utils/numberFormat";
import { calculateIslemAnindaBakiyeMap } from "../utils/IslemAnindaBakiyeUtil";

const ziynetShortMap = {
  "Yeni ATA": "YA",
  "Yeni YARIM": "YY",
  "Yeni ÇEYREK": "YÇ",
  "Eski ATA": "EA",
  "Eski YARIM": "EY",
  "Eski ÇEYREK": "EÇ",
};

const formatIslemTurWithZiynet = (r) => {
  const base = formatEnum(r.islemTur);


  if (!r?.islemTur?.startsWith("ZIYNET")) {
    return base;
  }

  const short = ziynetShortMap[r.stokAdi];
  return short ? `${base} (${short})` : base;
};

export const downloadHesapWord = ({
  allRows,
  filteredRows,
  hesapAdi,
  filterStart,
  filterEnd,
}) => {

  const bakiyeMap = calculateIslemAnindaBakiyeMap(allRows);

  const startText = filterStart
    ? new Date(filterStart).toLocaleDateString("tr-TR")
    : "";

  const endText = filterEnd
    ? new Date(filterEnd).toLocaleDateString("tr-TR")
    : "";

  const getEffectiveBirim = (r) => {
    if (
      r.islemTur === "NAKIT_ISLEM_GRAM_ALINDI" ||
      r.islemTur === "NAKIT_ISLEM_GRAM_VERILDI"
    ) {
      return "GRAM";
    }

    return r.birim ?? "";
  };

  const tarihBaslik =
    startText || endText
      ? `${startText || "..."} – ${endText || "..."} tarihleri arasındaki işlemler`
      : "Tüm İşlemler";

      const rowsHtml = (filteredRows || [])
        .map((r) => {
          const tarih = r.tarih ? new Date(r.tarih).toLocaleString("tr-TR") : "";
          const rec = bakiyeMap[Number(r.id)];

          const bakiyeText =
            rec && rec.value != null ? formatNumberTR(rec.value) : "0";

          return `
            <tr>
              <td>${tarih}</td>
              <td>${formatIslemTurWithZiynet(r)}</td>
              <td>${formatNumberTR(r.borc)}</td>
              <td>${formatNumberTR(r.alacak)}</td>
              <td>${getEffectiveBirim(r)}</td>
              <td>${bakiyeText}</td>
              <td>${(r.aciklama ?? "").toString()}</td>
            </tr>
          `;
        })
        .join("");

      const html = `
      <html>
        <head>
          <meta charset="utf-8" />
          <style>
            body { font-family: Arial, sans-serif; }
            h2 { color: #b8860b; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; font-size: 12px; }
            th { background: #f7f1df; }
          </style>
        </head>
        <body>

            <!-- LOGO -->
            <div style="text-align:center;font-size:32px;margin-bottom:2px;
             color:#b8860b;">
              🍎
            </div>

            <div style="
              text-align:center;
              font-size:12px;
              font-weight:bold;
              margin-bottom:4px;
              color:#b8860b;
              ">
              Proset
            </div>


            <!-- HESAP ADI -->
            <div style="
              text-align:center;
              font-size:16px;
              font-weight:bold;
              margin-bottom:4px;
            ">
              ${hesapAdi}
            </div>

            <!-- TARİH ARALIĞI -->
            <div style="
              text-align:center;
              font-size:12px;
              margin-bottom:16px;
              color:#555;
            ">
              ${tarihBaslik}
            </div>

          <table>
            <thead>
              <tr>
                <th>Tarih</th>
                <th>Tür</th>
                <th>Verilen</th>
                <th>Alınan</th>
                <th>Birim</th>
                <th>Bakiye</th>
                <th>Açıklama</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
        </body>
      </html>`;

      const blob = new Blob([html], { type: "application/msword;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "hesap-islemleri.doc";
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(url);

};
